/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';

import {
    IInfraCloudState,
    initialInfraCloudState,
} from './infra-cloud.state';

import { InfraCloudActions } from './infra-cloud-store.actions';

export const infraCloudStateReducer = createReducer(
    initialInfraCloudState,
    on(
        InfraCloudActions.setCloud,
        (state, action): IInfraCloudState => (
            {
                ...state,
                cloud: action.cloud,
            }
        ),
    ),
);
